var document = require('./_global').document;
module.exports = document && document.documentElement;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/modules/_html.js